import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { identityApi } from '@/api/identity.api';
import { PortalDataList } from './PortalDataList';
import { showApiError } from '@/utils/apiError';

export function CandidatePortalSections() {
  const { pathname } = useLocation();
  const section = pathname.split('/').pop() ?? 'dashboard';

  if (section === 'interviews') return <CandidateListSection title="Interviews" loader={identityApi.candidateInterviews} primaryKey="interviewType" metaKey="statusCode" />;
  if (section === 'offers') return <CandidateListSection title="Offer letters" loader={identityApi.candidateOffers} primaryKey="statusCode" metaKey="statusCode" />;
  if (section === 'documents') {
    return <CandidateListSection title="Documents" loader={identityApi.candidateDocuments} primaryKey="itemLabel" metaKey="statusCode" />;
  }
  if (section === 'onboarding') {
    return <CandidateListSection title="Onboarding tasks" loader={identityApi.candidateOnboarding} primaryKey="itemLabel" metaKey="statusCode" />;
  }
  if (section === 'applications' || section === 'status') return <CandidateOverviewSection />;  return <CandidateOverviewSection />;
}

function CandidateOverviewSection() {
  const [overview, setOverview] = useState<Record<string, unknown>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void identityApi.candidateOverview()
      .then(setOverview)
      .catch((e) => showApiError(e, 'Could not load application'))
      .finally(() => setLoading(false));
  }, []);

  const items = overview.fullName
    ? [{
        id: String(overview.candidateId ?? 1),
        primary: String(overview.fullName),
        secondary: overview.stage ? `Stage: ${String(overview.stage)}` : undefined,
        meta: overview.stage ? String(overview.stage) : undefined,
      }]
    : [];

  return <PortalDataList title="Application status" loading={loading} items={items} />;
}

function CandidateListSection({
  title,
  loader,
  primaryKey,
  metaKey,
}: {
  title: string;
  loader: () => Promise<Array<Record<string, unknown>>>;
  primaryKey: string;
  metaKey: string;
}) {
  const [items, setItems] = useState<Array<{ id: string | number; primary: string; meta?: string }>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void loader()
      .then((rows) => setItems(rows.map((r, i) => ({
        id: Number(r.id ?? i),
        primary: String(r[primaryKey] ?? title),
        meta: r[metaKey] != null ? String(r[metaKey]) : undefined,
      }))))
      .catch((e) => showApiError(e, `Could not load ${title.toLowerCase()}`))
      .finally(() => setLoading(false));
  }, [loader, primaryKey, metaKey, title]);

  return <PortalDataList title={title} loading={loading} items={items} emptyMessage={`No ${title.toLowerCase()} yet.`} />;
}
